import { supabase } from "./supabase";

const TABLE = "organisation_geofences";

export const getOrganisationGeofence = async (organisationId) => {
  if (!organisationId) return null;
  const { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .eq("organisation_id", organisationId)
    .maybeSingle();
  if (error) throw error;
  return data;
};

export const upsertOrganisationGeofence = async ({
  organisationId,
  address,
  center,
  polygon,
}) => {
  if (!organisationId) throw new Error("organisationId required");
  const { data: userResp } = await supabase.auth.getUser();
  const updated_by = userResp?.user?.id ?? null;

  const row = {
    organisation_id: organisationId,
    address: address ?? null,
    center_lat: center?.lat ?? null,
    center_lng: center?.lng ?? null,
    polygon: polygon ?? null,
    updated_at: new Date().toISOString(),
    updated_by,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .upsert(row, { onConflict: "organisation_id" })
    .select()
    .single();
  if (error) throw error;
  return data;
};
